<template>
  <div class="h-100 d-flex flex-column">
    <app-title-bar>
      <app-material-icon name="id_card" />
      <h2 class="text-text-primary">{{ $t('profile.views.IdentityChecking.title') }}</h2>
    </app-title-bar>
    <AppCard elevation="0" class="ma-8 flex-grow-1">
      <div class="d-flex flex-column row-gap-6 justify-center align-center layout-spacing">
        <template v-if="idCheckStatePending">
          <v-progress-circular size="24" indeterminate/>
        </template>
        <template v-else>
          <template v-if="canCurrentUserSign">
            <div class="d-flex align-center ga-2">
              <app-material-icon color="icon-success" name="check_circle" />
              <span class="text-text-secondary">{{ $t('profile.views.IdentityChecking.verified', { untilDate: validUntilDate }) }}</span>
            </div>
          </template>
          <template v-else>
            <p class="text-text-primary">{{ $t('profile.views.IdentityChecking.notVerified') }}</p>
            <app-button
              class="mx-auto"
              @click="SET_SHOW_IDENTITY_CHECK_MODAL(true)"
            >
              {{ $t('profile.views.IdentityChecking.verifyBtn') }}
            </app-button>
          </template>
        </template>
      </div>
    </AppCard>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import AppCard from '@/common/AppCard.vue'

import { ISOToDDMMYYYY } from '../../common/utils/dates'
import { GET_ID_CHECK_STATE } from '../../store/modules/user/action_types'
import { SET_SHOW_IDENTITY_CHECK_MODAL } from '../../store/modules/user/mutation_types'

const { mapMutations, mapActions, mapState } = createNamespacedHelpers('user')

export default {
  name: 'IdentityChecking',
  components: {AppCard},
  computed: {
    ...mapState(['idCheckState', 'idCheckStatePending']),
    canCurrentUserSign () {
      return this.idCheckState && this.idCheckState.hasValidIdCheck
    },
    validUntilDate () {
      return this.canCurrentUserSign && ISOToDDMMYYYY(this.idCheckState.idCheckValidUntil)
    },
  },
  created () {
    this.GET_ID_CHECK_STATE()
  },
  methods: {
    ...mapActions([GET_ID_CHECK_STATE]),
    ...mapMutations([SET_SHOW_IDENTITY_CHECK_MODAL]),
  },
}
</script>
